// app/javascript/controllers/time_blocks_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal"]

  openModal() {
    this.modalTarget.classList.remove("hidden")
    // Focus sur le premier input
    const firstInput = this.modalTarget.querySelector('input[type="datetime-local"]')
    if (firstInput) {
      setTimeout(() => firstInput.focus(), 100)
    }
  }

  closeModal() {
    this.modalTarget.classList.add("hidden")
    // Reset form
    const form = this.modalTarget.querySelector('form')
    if (form) {
      form.reset()
    }
  }

  // Fermer avec Escape
  keydown(event) {
    if (event.key === "Escape") {
      this.closeModal()
    }
  }
}
